var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFacebookKnockout(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Facebook-knockout") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Facebook-knockout",
    stroke: "none",
    strokeWidth: 1,
    fill: "#00265f",
    fillRule: "evenodd",
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("g", {
    id: "FB",
    transform: "translate(1.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.244,14.622 C29.244,22.697 22.698,29.243 14.622,29.243 C6.547,29.243 0,22.697 0,14.622 C0,6.546 6.547,0 14.622,0 C22.698,0 29.244,6.546 29.244,14.622",
    id: "Fill-105",
    stroke: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.313,18.849 L20.961,14.622 L16.907,14.622 L16.907,11.879 C16.907,10.723 17.473,9.596 19.289,9.596 L21.133,9.596 L21.133,5.997 C21.133,5.997 19.459,5.712 17.86,5.712 C14.52,5.712 12.337,7.736 12.337,11.4 L12.337,14.622 L8.624,14.622 L8.624,18.849 L12.337,18.849 L12.337,29.065 C13.081,29.183 13.844,29.243 14.621,29.243 C15.399,29.243 16.161,29.183 16.907,29.065 L16.907,18.849 L20.313,18.849",
    id: "Fill-121",
    fill: "#FFFFFF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookKnockout);
export default __webpack_public_path__ + "static/media/Facebook-knockout.386f48809f8793dd684e1b5328c18adb.svg";
export { ForwardRef as ReactComponent };